// extracted by mini-css-extract-plugin
export var footnoteLink = "FootnoteLink-module--footnoteLink--a7797";
export var footnoteLinkParenthesis = "FootnoteLink-module--footnoteLinkParenthesis--78a5d";
export var footnotePlaceholder = "FootnoteLink-module--footnotePlaceholder--8cbc7";
export var footnoteSuper = "FootnoteLink-module--footnoteSuper--ccb8f";